// 非体验版

// 登录
import CLogin from '@/components/Page/CLogin/CLogin'
// 仪表盘
import CMap from '@/components/CMap'
// 主页
import CIndex from '@/components/CIndex'

// 其他
import CLoginSetting from '@/components/Page/COther/CLoginSetting'
import CModifyPassword from '@/components/Page/COther/CModifyPassword'

// 用户管理
import COrganizeManage from '@/components/Page/CUserManege/COrganizeManage/SIndex'  // 组织管理
import COrganizeAuthAllot from '@/components/Page/CUserManege/COrganizeManage/COrganizeAuthAllot'   //权限分配
import CCasualUser from '@/components/Page/CUserManege/CCasualUser'  // 临时用户

// 场景管理
import CSceneList from '@/components/Page/CSceneManage/CSceneList'  //空间管理
import CDeviceCenter from '@/components/Page/CSceneManage/CDeviceCenter';//设备中心
import CDeviceManage from '@/components/Page/CSceneManage/CDeviceManage/CDeviceManage';//设备管理

// 平台运营
import CEnterprisePayment from '@/components/Page/CPlatformOperate/CEnterprisePayment'
import CPlatFormPay from '@/components/Page/CPlatformOperate/CPlatFormPay'
import CSMSRecharge from '@/components/Page/CPlatformOperate/CSMSRecharge'
import CSMSLog from '@/components/Page/CPlatformOperate/CSMSLog'
import CBillingInfo from '@/components/Page/CPlatformOperate/CBillingInfo'

// 授权管理
import CAuthorizationCenter from '@/components/Page/CAuthorizationManage/CAuthorizationCenter'
import CBeAuthorizedUser from '@/components/Page/CAuthorizationManage/CBeAuthorizedUser'
import CBusiness from '@/components/Page/CAuthorizationManage/CBusiness'
import CESite from '@/components/Page/CAuthorizationManage/CESite';//E站
import CUnmanWarehouse from '@/components/Page/CAuthorizationManage/CUnmanWarehouse';//无人仓
import CFamilyGuard from '@/components/Page/CAuthorizationManage/CFamilyGuard';//家庭卫士
import CMakeAppointment from '@/components/Page/CAuthorizationManage/CMakeAppointment';//预约
import CExpress from '@/components/Page/CAuthorizationManage/CExpress';//快递
import CTactics from '@/components/Page/CAuthorizationManage/CTactics';//扫码支付
import CAccess from '@/components/Page/CAuthorizationManage/CAccess';//门禁预约
import CConference from '@/components/Page/CAuthorizationManage/CConference';//会议室预约

// 能耗管理
import CAmmeterManage from '@/components/Page/CEnergyManage/CAmmeterManage'

// 碧水湾
import COpenLog from '@/components/Page/CBsw/COpenLog';//开门记录
import CVisitorExamine from '@/components/Page/CBsw/CVisitorExamine';//访客审核

// 客户管理
import CCustomerList from '@/components/Page/CCustomer/CCustomerList';//客户列表
import CCustAuthAllot from '@/components/Page/CCustomer/CCustAuthAllot';//客户权限分配
import CProductSales from '@/components/Page/CCustomer/CProductSales';//产品销售
import CMaintain from '@/components/Page/CCustomer/CMaintain';//客户运维

//仓储业务
import CStorage from '@/components/Page/CStorage/CStorage';//仓储业务首页
import CWarehouseManage from '@/components/Page/CStorage/CWarehouseManage/CWarehouseManage';//仓库管理
import CDeviceBind from '@/components/Page/CStorage/CWarehouseManage/CDeviceBind';//设备绑定
import CProductManage from '@/components/Page/CStorage/CProductManage/CProductManage';//产品管理
import CBookManage from '@/components/Page/CStorage/CBookManage/CBookManage';//预约管理
import CAddBook from '@/components/Page/CStorage/CBookManage/CAddBook';//添加预约单
import COutInWareManage from '@/components/Page/CStorage/COutInWareManage/COutInWareManage';//出入库管理
import CAddInware from '@/components/Page/CStorage/COutInWareManage/CAddInware';//添加入库单
import CAddOutware from '@/components/Page/CStorage/COutInWareManage/CAddOutware';//添加出库单
import CInventoryRecord from '@/components/Page/CStorage/CInventoryRecord/CInventoryRecord';//库存记录
import CStoreRecord from '@/components/Page/CStorage/CStoreRecord/CStoreRecord';//盘点记录
import CAddStore from '@/components/Page/CStorage/CStoreRecord/CAddStore';//添加盘点记录
import CReview from '@/components/Page/CStorage/CReview/CReview';//复核管理
import CInitManage from '@/components/Page/CStorage/CInitManage/CInitManage';//初始化管理
import CProductAuth from '@/components/Page/CStorage/CProductAuth/CProductAuth';//产品授权

//绿瘦
import CInventoryRecords from '@/components/Page/CInventoryModule/CInventoryRecords'  // 盘点记录

import CIframe from '@/components/Page/Layout/CIframe'



let router = [
  // 登录
  {
    path: '/',
    name: 'CLogin',
    component: CLogin,
    meta: {
      rv: 0
    }
  },
  // 带company_ic登录
  {
    path: '/icl/:company_ic',
    name: 'CLogin_ic',
    component: CLogin,
    meta: {
      rv: 0
    }
  },
  // 仪表盘，即 地图
  {
    path: '/CMap/',
    name: 'CMap',
    component: CMap,
    meta: {
      rv: 0,
      isMap: true
    }
  },
  {
    path: '/CMap/:mapLevel/:id',
    name: 'CMapRoute',
    component: CMap,
    meta: {
      rv: 0,
      isMap: true
    }
  },
  // 首页
  {
    path: '/CIndex/',
    name: 'CIndex',
    component: CIndex,
    meta: {
      rv: 1
    }
  },
  // 第三方应用
  {
    path: '/CThirdApplication/:num',
    name: 'CIndexThird',
    component: CIndex,
    meta: {
      rv: 1
    }
  },
  // 其他
  {
    path: '/CLoginSetting/',
    name: 'CLoginSetting',
    component: CLoginSetting,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CModifyPassword/',
    name: 'CModifyPassword',
    component: CModifyPassword,
    meta: {
      rv: 1
    }
  },
  // 用户管理
  {
    path: '/COrganizeManage/',
    name: 'COrganizeManage',
    component: COrganizeManage,
    meta: {
      rv: 1
    }
  },
  {
    path: '/COrganizeAuthAllot/',
    name: 'COrganizeAuthAllot',
    component: COrganizeAuthAllot,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CCasualUser/',
    name: 'CCasualUser',
    component: CCasualUser,
    meta: {
      rv: 1
    }
  },
  // 场景管理
  {
    path: '/CSceneList/',
    name: 'CSceneList',
    component: CSceneList,
    meta: {
      rv: 1
    }
  },

  {
    path: '/CDeviceCenter/',
    name: 'CDeviceCenter',
    component: CDeviceCenter,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CDeviceManage/',
    name: 'CDeviceManage',
    component: CDeviceManage,
    meta: {
      rv: 1
    }
  },

  // 平台运营
  {
    path: '/CEnterprisePayment/',
    name: 'CEnterprisePayment',
    component: CEnterprisePayment,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CPlatFormPay/',
    name: 'CPlatFormPay',
    component: CPlatFormPay,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CSMSRecharge/',
    name: 'CSMSRecharge',
    component: CSMSRecharge,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CSMSLog/',
    name: 'CSMSLog',
    component: CSMSLog,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CBillingInfo/',
    name: 'CBillingInfo',
    component: CBillingInfo,
    meta: {
      rv: 1
    }
  },
  // 授权管理
  {
    path: '/CAuthorizationCenter/',
    name: 'CAuthorizationCenter',
    component: CAuthorizationCenter,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CBeAuthorizedUser/',
    name: 'CBeAuthorizedUser',
    component: CBeAuthorizedUser,
    meta: {
      rv: 1
    }
  },
  //业务领域
  {
    path: '/CBusiness/',
    name: 'CBusiness',
    component: CBusiness,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CESite/',
    name: 'CESite',
    component: CESite,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CUnmanWarehouse/',
    name: 'CUnmanWarehouse',
    component: CUnmanWarehouse,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CFamilyGuard/',
    name: 'CFamilyGuard',
    component: CFamilyGuard,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CMakeAppointment/',
    name: 'CMakeAppointment',
    component: CMakeAppointment,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CExpress/',
    name: 'CExpress',
    component: CExpress,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CTactics/',
    name: 'CTactics',
    component: CTactics,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CAccess/',
    name: 'CAccess',
    component: CAccess,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CConference/',
    name: 'CConference',
    component: CConference,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CStorage/',
    name: 'CStorage',
    component: CStorage,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CWarehouseManage/',
    name: 'CWarehouseManage',
    component: CWarehouseManage,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CDeviceBind/',
    name: 'CDeviceBind',
    component: CDeviceBind,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CProductManage/',
    name: 'CProductManage',
    component: CProductManage,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CBookManage/',
    name: 'CBookManage',
    component: CBookManage,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CAddBook/',
    name: 'CAddBook',
    component: CAddBook,
    meta: {
      rv: 1
    }
  },
  {
    path: '/COutInWareManage/',
    name: 'COutInWareManage',
    component: COutInWareManage,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CAddInware/',
    name: 'CAddInware',
    component: CAddInware,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CAddOutware/',
    name: 'CAddOutware',
    component: CAddOutware,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CInventoryRecord/',
    name: 'CInventoryRecord',
    component: CInventoryRecord,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CStoreRecord/',
    name: 'CStoreRecord',
    component: CStoreRecord,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CAddStore/',
    name: 'CAddStore',
    component: CAddStore,
    meta: {
      rv: 1
    }
  },{
    path: '/CReview/',
    name: 'CReview',
    component: CReview,
    meta: {
      rv: 1
    }
  },{
    path: '/CInitManage/',
    name: 'CInitManage',
    component: CInitManage,
    meta: {
      rv: 1
    }
  },{
    path: '/CProductAuth/',
    name: 'CProductAuth',
    component: CProductAuth,
    meta: {
      rv: 1
    }
  },
  

  // 能耗管理
  {
    path: '/CAmmeterManage/',
    name: 'CAmmeterManage',
    component: CAmmeterManage,
    meta: {
      rv: 1
    }
  },
  // 碧水湾
  {
    path: '/COpenLog/',
    name: 'COpenLog',
    component: COpenLog,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CVisitorExamine/',
    name: 'CVisitorExamine',
    component: CVisitorExamine,
    meta: {
      rv: 1
    }
  },

  // 客户管理
  {
    path: '/CCustomerList/',
    name: 'CCustomerList',
    component: CCustomerList,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CCustAuthAllot/',
    name: 'CCustAuthAllot',
    component: CCustAuthAllot,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CProductSales/',
    name: 'CProductSales',
    component: CProductSales,
    meta: {
      rv: 1
    }
  },
  {
    path: '/CMaintain/',
    name: 'CMaintain',
    component: CMaintain,
    meta: {
      rv: 1
    }
  },
  //绿瘦盘点管理
  {
    path: '/CInventoryRecords/',
    name: 'CInventoryRecords',
    component: CInventoryRecords,
    meta: {
      rv: 1
    }
  },

  //基站节能，跳到iframe页
  {
    path: '/CBaseStation/',
    name: 'CBaseStation',
    component: CIframe,
    meta: {
      rv: 1
    }
  },

]



export default router


// WEBPACK FOOTER //
// ./src/router/modules/Page.js